// extracted by mini-css-extract-plugin
module.exports = {"widgetsSectionHeader":"WidgetsSectionHeader_widgetsSectionHeader__1HmAA","headerLeft":"WidgetsSectionHeader_headerLeft__aDXAJ"};